import type { SVGProps } from 'react'
const SvgSySunlight = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="M16 12a4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4" />
		<path d="M12 7.4A4.61 4.61 0 0 0 7.4 12c0 2.533 2.067 4.6 4.6 4.6s4.6-2.067 4.6-4.6-2.067-4.6-4.6-4.6m0 1.2c1.885 0 3.4 1.515 3.4 3.4s-1.515 3.4-3.4 3.4-3.4-1.515-3.4-3.4 1.515-3.4 3.4-3.4" />
		<path d="M11.4 4v4h1.2V4zm0 12v4h1.2v-4zM6.768 5.918l-.848.85 2.828 2.828.848-.848zm8.484 8.486-.848.848 2.828 2.83.85-.85zM16 11.4v1.2h4v-1.2zm-12 0v1.2h4v-1.2zm13.232-5.482-2.828 2.83.848.848 2.828-2.828zm-8.484 8.486-2.83 2.828.85.85 2.828-2.83z" />
	</svg>
)
export default SvgSySunlight
